module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/size-sm-3d17e8ea99d7c82bc18d2d2593f77843.svg";